/* @flow */

declare var API_ENDPOINT: string;

let link;
if (API_ENDPOINT) {
  link = require('./link.srv').default;
} else {
  link = require('./link.local').default;
}

export default link;
